import { LIB_VERSION } from './version';
export const CSS_CDN_URL = `https://static.parastorage.com/unpkg/@wix/design-system@${LIB_VERSION}/dist/statics/styles.global.css`;
export const JS_ESM_CDN_URL = `https://static.parastorage.com/unpkg/@wix/design-system@${LIB_VERSION}/dist/statics/design-system.esm.min.js`;
//# sourceMappingURL=CDN_URLS.js.map